// SupportUs.tsx
'use client';

import React from 'react';
import { useSiteLanguage } from '@/lib/SiteLanguageContext';

export default function SupportUs() {
  const { siteLang } = useSiteLanguage();
  const t = siteLang === 'en'
    ? {
        heading: 'Support Our Work',
        desc: 'If you enjoy our content, please consider supporting us! Your donation helps keep this blog free and independent.'
      }
    : {
        heading: 'Podržite naš rad',
        desc: 'Ako uživate u našem sadržaju, razmislite o podršci! Vaša donacija pomaže da ovaj blog ostane besplatan i nezavisan.'
      };
  return (
    <div style={{
      background: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      padding: '2rem',
      margin: '2rem auto',
      maxWidth: 480,
      textAlign: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    }}>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#222' }}>{t.heading}</h2>
      <p style={{ marginBottom: '1.5rem', color: '#444' }}>{t.desc}</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
        {/* PayPal Donation Only */}
        <a
          href="https://paypal.me/studijeOS"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: '#0070ba',
            color: '#fff',
            borderRadius: '6px',
            padding: '0.7rem 2rem',
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
        >
          💙 Donate via PayPal
        </a>
        <a
          href="https://ko-fi.com/studijeodbrambenihsistema"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: '#29abe0',
            color: '#fff',
            borderRadius: '6px',
            padding: '0.7rem 2rem',
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
        >
          ☕ Support us on Ko-fi
        </a>
      </div>
    </div>
  );
}
